export default __webpack_public_path__ + "static/media/bogo.59845917.jpg";